<div class="block" style="margin-top: 2%; margin-bottom: 0" *ngIf="batchTransactions && batchTransactions.length>0">
  <div class="batch-data-block">
    <div
      *ngFor="let item of batchTransactionsList; let i = index">
      <p class="batchdata"
         (click)="getBatchEntryDetailsByBatchNumber(item.id, item.date_time);">
        <span>{{item.batch_number}}</span>
        <span
          style="margin-left: 20px;">Batch Date(Time): {{((item.createdAt.split('T')[0])| date)}} {{convertTo24Hrs(item.date_time)}}</span>
        <span style="margin-left: 20px; float: right">Feed Date: {{((item.date_time.split('T')[0])| date)}}</span>
      </p>
    </div>
    <div *ngIf="listLoader" class="loader-div">
      <div class="adjust">
        <div class="loader2 list-loader"></div>
      </div>
    </div>
  </div>
  <div class="modal fade" id="myModal" role="dialog">
    <div class="modal-dialog modal-lg">
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" title="Close Popup">&times;
          </button>
        </div>
        <div *ngIf="selectedBatchTimeStamp" class="time-stamp-div">
          <span
            class="time-stamp-span">Feed Date: {{((selectedBatchTimeStamp.split('T')[0])| date)}}</span>
        </div>
        <div class="modal-body batch-details-popup">
          <div class="row treatlist" [ngClass]="{'treatlist' : feedLogsData && feedLogsData.length>2 }">
            <div class="row mealcard" *ngFor="let meal of feedLogsData">
              <p class="meal-tank">Tank: {{meal && meal.Ponds && meal.Ponds.name}}</p>
              <table class="table table-bordered table-striped text-center">
                <thead>
                <tr>
                  <th>S.No</th>
                  <th>Meal Date</th>
                  <th>Meal</th>
                  <th>Feed Type</th>
                  <th>Skip Reason</th>
                  <th>Quantity</th>
                  <th>UOM</th>
                  <th>Feed Mix</th>
                  <th>Quantity</th>
                  <th>UOM</th>
                  <th>Feed Given(kgs)</th>
                  <th>Check tray Given(Grams)</th>
                  <th>Check tray Consumed(Grams)</th>
                  <th>Last Meal</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let item of meal.feedMeal let i = index;">
                  <td>{{i + 1}}</td>
                  <td>{{item.feedLogObject.last_feed_given_date}}</td>
                  <td>{{item.meal}}</td>
                  <td>{{item.feedItemMaster.item_name}}<span
                    *ngIf="item && item.feedItemMaster.sub_type">-</span> {{item && item.feedItemMaster.sub_type}}</td>
                  <td>{{item.skip_reason == '' ? 'NA' : item.skip_reason}}</td>
                  <!--<td *ngIf="item.feed_uom_id != 3">{{item.feed_qty_given ? item.feed_qty_given / 1000 : "NA"}}</td>
                  <td *ngIf="item.feed_uom_id == 3">{{item.feed_qty_given ? item.feed_qty_given : 'NA'}}</td>-->
                  <td>{{item.feed_qty_given ? item.feed_qty_given : 'NA'}}</td>
                  <td>{{(item.feedUomMaster ? item.feedUomMaster.name : 'NA')}}</td>
                  <!--                  <td>{{item.mix_item_id && (item.mix_item_id != "-1" || item.mix_item_id !=null) ? item.mixItemMaster.item_name : "NA"}}<span *ngIf="item && item.mixItemMaster.sub_type">-</span> {{item && item.mixItemMaster.sub_type}}</td>-->
                  <td>{{(item && item.mixItemMaster && item.mixItemMaster.item_name) ? (item && item.mixItemMaster && item.mixItemMaster.item_name) : 'NA'}}
                    <span
                      *ngIf="item && item.mixItemMaster && item.mixItemMaster.sub_type">-</span> {{item && item.mixItemMaster && item.mixItemMaster.sub_type}}
                  </td>
                  <td>{{item.mix_qty_given ? (item.mix_qty_given | currencyFormat) : "NA"}}</td>
                  <td>{{item.mixUomMaster ? item.mixUomMaster.name : "NA"}}</td>
                  <!--<td
                    *ngIf="item.feed_uom_id == 3">{{(item.feed_qty_given) ? (((item.feed_qty_given) / 1000)) : "NA"}}</td>
                  <td
                    *ngIf="item.feed_uom_id != 3">{{(item.feed_qty_given) ? ((item.feed_qty_given) / 1000) : "NA"}}</td>-->
                  <td>{{(item.feedLogObject.feed_given) ? ((item.feedLogObject.feed_given / 1000)) : "NA"}}</td>
                  <td>{{(item && item.checkTray && item.checkTray && item.checkTray.check_tray_feed_given) ? (item && item.checkTray && item.checkTray && item.checkTray.check_tray_feed_given + " Grams") : 'NA'}}</td>
                  <td>{{(item && item.checkTray && item.checkTray && item.checkTray.check_tray_feed_consumed) ? (item && item.checkTray && item.checkTray && item.checkTray.check_tray_feed_consumed + " Grams") : 'NA'}}</td>
                  <td>
                    <input type="checkbox" [(ngModel)]="item.last_meal" disabled></td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
